// extracted by css-extract-rspack-plugin
export default {"iconWrapper":"JEdFO4IlYP0fZXkQ","textContent":"AOqjjzmrR8obIOjZ"};